// PaymentFailed.js
const PaymentFailed = () => (
    <div>
        <h1>Payment Failed!</h1>
        <p>The transaction was failed.Please try again.</p>
    </div>
);
export default PaymentFailed;
